var iconLg = {
  "fontSize": "3rem",
  "&::before": {
    "fontSize": "3rem"
  }
};

export { iconLg };
